import { ItemObject, SourcingScenarioDTO } from '@luminovo/http-client';

export const calculateTotalOrderSize = (sourcingScenario: SourcingScenarioDTO): number => {
    return sourcingScenario.assembly_quantities.items.reduce((total: number, assembly: ItemObject) => {
        return total + assembly.quantity;
    }, 0);
};
